<template>
  <div class="container">
    <div class="top">
      <!-- 搜索 -->
      <div class="search-top">
        <img :src="logo" alt="" class="img" width="23" height="23">
        <div class="search"
             @click="$router.push('/search')">
          <img src="@/assets/search.png"
               alt=""
               class="img">
          <span class="text">搜索商品名称或型号,例如: 电子商品</span>
        </div>
        <div @click="$router.push('/search')">搜索</div>
      </div>
      <!-- 分类 -->
      <div class="tabs row">
        <div class="tab"
             v-text="item.name"
             v-for="(item,index) in tabList"
             :key="index"
             :class="[index==activeTag?'active':'']"
             @click="handleTag(index,item)"></div>
      </div>
    </div>

    <!-- 轮播图 -->
    <Swiper :banner="bannerList" />

    <!-- 快捷菜单 -->
    <!-- <Category :cateList="cateList" /> -->
    <AutoScrollNav :cateList="cateList"/>

    <!-- 商城公告 -->
    <Notice :noticeList="noticeList" />

    <!-- 促销模块 -->
    <Nav :navList="navList" />

    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block" style="position: relative">
          <img src="@/assets/drawBack.png" alt="" width="283" height="343">
          <img src="@/assets/drawBtn.png" alt="" width="134" height="47" style="position: absolute;bottom: 5.5rem" @click="toPageCoupon">
          <img src="@/assets/drawClose.png" alt="" width="35" height="35" style="margin-top: 3rem" @click="addLoginCount">
        </div>
      </div>
    </van-overlay>

    <!-- 推荐商品 -->
    <Goods />

    <tabbar></tabbar>
  </div>



</template>

<script>
import {getCurtUser,addLoginCount} from '@/api/login/index.js'
import wx from 'weixin-jsapi'
import {getSignature1} from '@/api/login/wx'
import Swiper from './modules/Swiper'
import Category from './modules/Category'
import AutoScrollNav from './modules/AutoScrollNav.vue'
import Notice from './modules/Notice'
import Nav from './modules/Nav'
import Goods from './modules/Goods'
import { getShopCategoryList,getHomeOneCategory } from '@/api/category'
import { getSysNavList } from '@/api/nav'
import { getShopModuleList } from '@/api/module'
import { getSysBannerList } from '@/api/banner'
import { getSysNoticeList } from '@/api/notice'
import { getSysSetting } from '@/api/system'
export default {
  name: 'home',
  components: {
    Swiper,
    AutoScrollNav,
    Notice,
    Nav,
    Goods
  },
  data () {
    return {
      show: false,
      activeTag: 0,
      logo: '',
      tabList: [],
      cacheData: {},
      bannerList: [
        { id: 1, name: '轮播图1', url: 'https://img.yzcdn.cn/vant/apple-1.jpg' },
        { id: 2, name: '轮播图2', url: 'https://img.yzcdn.cn/vant/apple-2.jpg' }
      ],
      noticeList: [],
      navList: [],
      cateList: []
    }
  },
  created () {

  },
  beforeRouteEnter (to, from, next) {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // XXX: 修复iOS版微信HTML5 History兼容性问题
    if (isiOS && to.path !== location.pathname) {
      // 此处不可使用location.replace
      location.assign(to.fullPath)
    } else {
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    if(to.name == 'productDetail' || to.name == 'productShopList') {
      localStorage.setItem("scroll", document.querySelector(".container").scrollTop)
    } else localStorage.setItem("scroll", 0)
    next()
  },
  activated:function() {
    this.$nextTick(() => {
      console.log(111111111111112222)
      document.querySelector(".container").scrollTop = localStorage.getItem("scroll")
      localStorage.setItem("scroll", 0)
    })

  },
  mounted(){
    this.init(location.href);
    this.getBanner()
    this.getTab()
    this.getCate()
    this.getNotice()
    this.getModule()
    this.getSysSetting()
    var pid = this.getUrlKey('pid');
    if (pid != null) {
      localStorage.setItem('pid',pid)
    }
    var openid = this.getUrlKey('openid')
    if (openid != null) {
      localStorage.setItem('openid', openid)
      this.getUser(openid)
    }
    var headImg = this.getUrlKey('headImg')
    if (headImg != null) {
      localStorage.setItem('headImg', headImg)
    }
    var nickname = this.getUrlKey('nickname')
    if (nickname != null) {
      localStorage.setItem('nickname', nickname)
    }
    var token = this.getUrlKey('token')
    console.log('链接中的token', token)
    if (token != null) {
      localStorage.setItem('Authorization', token)
      localStorage.removeItem('userInfo')
    }

    let user = JSON.parse(localStorage.getItem("userInfo"));
    if (user && user.loginCount == 0){
      this.show = true;
    }


    var u = navigator.userAgent;
    var ua = window.navigator.userAgent.toLowerCase();
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      if (isiOS && (!this.getUrlKey("iosR"))) {
        if(window.location.href.indexOf("?") != -1) {
          window.location = window.location + '&iosR=1'
        } else {
          window.location = window.location + '?iosR=1'
        }
      }
    }
  },
  methods: {
    addLoginCount(){
      let user = JSON.parse(localStorage.getItem("userInfo"));
      if (!user){
        this.$router.push({
          path: '/login'
        })
        return;
      }
      addLoginCount({id: user.id}).then(res=>{
        this.show = false;
        this.userInfo = res.data
        localStorage.setItem('userInfo',JSON.stringify(res.data))
      })
    },
    toPageCoupon(){
      let user = JSON.parse(localStorage.getItem("userInfo"));
      if (user){
        this.addLoginCount();
        this.$router.push({ path: '/core'})
      } else{
        this.$router.push({
          path: '/login'
        })
      }
    },
    getUser(openid){
      getCurtUser({openid : openid}).then(res => {
        if (res.success) {
          if (res.data.loginCount == 0){
            this.show = true;
          }
          this.userInfo = res.data
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          localStorage.setItem('userCode', this.userInfo.code)
        }
      })
    },
    init(url){
      getSignature1({url: url}).then(response=>{
        if(response.success){
          wx.config({
            debug: false,
            appId: response.data.appId,
            timestamp: response.data.timestamp,
            nonceStr: response.data.nonceStr,
            signature: response.data.signature,
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
          });
        }else{
          //alert(response.msg);
        }
        this.share();
      })
    },
    share(){
      // 微信分享配置
      var that = this
      let userCode = localStorage.getItem('userCode')
      wx.ready(function () {
        // 分享给好友
        wx.onMenuShareAppMessage({
          title: '创客芯城', // 分享标题
          desc: "电子元器件、电子产品一站式采购自营商城 自购返利 推荐返佣金", // 分享描述
          link: "http://ckaicai.com/api/system/wx/login?pid=" + userCode, // 分享链接
          //imgUrl: '', // 分享图标
          success: function(res) {
            that.$toast.success('分享成功');
          },
          fail: function (res) {
            that.$toast.success(JSON.stringify(res));
          }
        })
        // 分享到朋友圈
        wx.onMenuShareTimeline({
          title: '创客芯城', // 分享标题
          desc: "电子元器件、电子产品一站式采购自营商城 自购返利 推荐返佣金", // 分享描述
          link: "http://ckaicai.com/api/system/wx/login?pid=" + userCode, // 分享链接
          //imgUrl: '', // 分享图标
          success:function(res){
            that.$toast.success('分享成功');
          },
          fail:function(res){
            that.$toast.success(JSON.stringify(res));
          }
        })
        //alert('请点击右上角分享按钮！');
      });
      wx.error(function (res) {
        //alert("出错了：" + res.errMsg);//这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
      });
    },
    //电子发票是否开启
    getSysSetting(){
      getSysSetting({}).then(res=>{
        if (res.success){
          this.logo = res.data.logo
        }
      })
    },
    getUrlKey(name){
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(decodeURI(window.location.href)) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    getBanner () {
      getSysBannerList({}).then(res => {
        if (res.success) {
          this.bannerList = res.data
        }
      })
    },
    getTab () {
      getHomeOneCategory({ pid: 0 }).then(res => {
        if (res.success) {
          this.tabList = res.data
        }
      })
    },
    getCate () {
      getSysNavList({}).then(res => {
        if (res.success) {
          this.cateList.push({type : 1,url:'/bom/add',icon : 'http://ckaicai.com/icon/bom.png',name : 'BOM表配单'})
          this.cateList.push({type : 1,url:'/purchase',icon : 'http://ckaicai.com/icon/purchase.png',name : '我要求购'})
          for (var item of res.data) {
            this.cateList.push(item)
          }
        }
      })
    },
    getNotice () {
      getSysNoticeList({}).then(res => {
        if (res.success) {
          this.noticeList = res.data
        }
      })
    },
    getModule () {
      getShopModuleList({}).then(res => {
        if (res.success) {
          this.navList = res.data
        }
      })
    },
    onNavigate (url) {
      this.$router.push({
        path: url
      })
    },
    handleTag (index, item) {
      this.activeTag = index
      this.$router.push({
        path: '/homeTop',
        query:{
          from : 'homeTop',
          activeTag: item.children[0]?item.children[0].id:'',
          id: item.id,
          name : item.name
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-overlay{
  z-index: 2003;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.container {
  // overflow: auto;
  width: 100vw;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: scroll;
  padding-bottom: 50px;
  padding-top: 100px;
  font-size: 14px;
  background-color: #ffffff;
  .top{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: white;
    z-index: 999;
  }
  .search-top{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 12px;
  }
  .search {
    height: 36px;
    margin: 6px 12px;
    border: 1px solid #fe003b;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    .img {
      width: 23px;
      height: 23px;
      vertical-align: middle;
      margin-right: 5px;
    }
    .text {
      font-size: 14px;
      color: #9f9f9f;
    }
  }
  .tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 44px;
    line-height: 44px;
    padding: 0 12px;
    overflow-x: scroll;
    -webkit-backface-visibility: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
    .tab {
      height: 25px;
      line-height: 25px;
      padding: 0 0.4rem;
      white-space: nowrap;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: #fe003b;
        border-bottom: 3px solid #fe003b;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue